import { array, boolean, date, InferType, mixed, number, object, ObjectSchema, string } from "yup";
import { EditarObraContract } from "../contracts/editar-obra.contract";
import { ModalityEnum, WorkStatusEnum } from "../../../shared/utils/enum/enum";
import { UnitOfMeasureEnum } from "../../../shared/components/formulario/select/SelectUnitOfMeasure";

export const editarObraSchema: ObjectSchema<EditarObraContract> = object({
    workName: string().required("Nome da obra é obrigatório"),
    idClient: string().required("Cliente é obrigatória"),
    startDate: date().required("Data de início é obrigatória"),
    endDate: date().required("Data de término é obrigatória"),
    totalValue: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            // Remove máscara e converte para número
            if (typeof originalValue === "string") {
                const valorNumber = Number(originalValue.replace(/\./g, "").replace(",", "."));
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .required("Valor total é obrigatório"),
    status: mixed<WorkStatusEnum>()
        .oneOf(Object.values(WorkStatusEnum), "Selecione uma Status")
        .required("Status é obrigatório"),
    description: string().nullable().default(null),
    address: object().shape({
        zipCode: string().required("CEP é obrigatório"),
        street: string().required("Rua é obrigatória"),
        number: string().required("Número é obrigatório"),
        neighborhood: string().required("Bairro é obrigatório"),
        city: string().required("Cidade é obrigatória"),
        state: string().required("Estado é obrigatório"),
        complement: string().default(""),
    }),
    contractFile: mixed<File>()
        .required("É obrigatório informar um arquivo")
        .test("fileRequired", "É obrigatório informar um arquivo", value => !!value),
    percentageOfWork: number()
        .typeError("Porcentagem de obra deve ser um número")
        .min(0, "Porcentagem de obra não pode ser negativa")
        .max(100, "Porcentagem de obra não pode ser maior que 100")
        .default(0)
        .required("Porcentagem de obra é obrigatória"),
    workStages: array()
        .of(
            object().shape({
                name: string().required("Nome da etapa é obrigatório"),
                description: string().nullable(),
                startDate: date().required("Data de início da etapa é obrigatória"),
                endDate: date().required("Data de término da etapa é obrigatória"),
                order: number().nullable(),
                percentage: number()
                    .typeError("Percentual deve ser um número")
                    .min(0, "Percentual não pode ser negativo")
                    .max(100, "Percentual não pode ser maior que 100")
                    .nullable()
                    .default(0)
                    .required("Porcentagem de obra é obrigatória"),
            })
        )
        .min(1, "É obrigatório informar ao menos uma etapa")
        .required("Etapas são obrigatórias")
        .default([]),
    positionsDto: array()
        .of(
            object().shape({
                name: string().required("Nome do cargo é obrigatório"),
                description: string().required("Descrição do cargo é obrigatória"),
                active: boolean().required(),
                priceDto: array()
                    .of(
                        object().shape({
                            value: number().required("Valor é obrigatório").transform((value, originalValue) => {
                                if (typeof originalValue === "string") {
                                    const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
                                    if (!cleaned) return undefined;
                                    const valorNumber = Number(cleaned);
                                    return isNaN(valorNumber) ? undefined : valorNumber;
                                }
                                return value;
                            }),
                            modality: mixed<UnitOfMeasureEnum>()
                                .oneOf(Object.values(UnitOfMeasureEnum), "Modalidade inválida")
                                .required("Modalidade é obrigatória"),
                            active: boolean().required(),
                        })
                    )
                    .required("É obrigatório informar ao menos um preço")
                    .min(1, "É obrigatório informar ao menos um preço"),
            })
        )
        .default([]),
});

export type EditarObraFormData = InferType<typeof editarObraSchema>;